import * as React from 'react';
import Button from '@mui/material/Button';
import { usePallet } from '../contexts/PalletContext';
import { useNavigate } from 'react-router-dom';
import { useAlert } from '../contexts/AlertContext';


export default function ButtonOutlineReadOnly(props: { path: string }) {
  const { pallet } = usePallet();
  // const navigate = useNavigate();
  const { NewAlert } = useAlert();

  return (
    <Button style={{
      backgroundColor: `${pallet.backGroundPageColorSecondary}`,
      color: `${pallet.textColorSecondary}`,
      border: `1px solid ${pallet.textColorSecondary}`,
      fontWeight: pallet.general.weight_600,
      padding: "10px 20px 10px 20px",
      fontFamily: `${pallet.general.fontFamily}`,
    }} variant="outlined" onClick={() => NewAlert("error", props.path)}>CADASTRAR</Button>
  );
}